import React from "react";
import { LoginCallback as OktaLoginCallback } from "@okta/okta-react";
import { Box, CircularProgress } from "@mui/material";

export default function LoginCallback(): React.ReactElement {
  return (
    <>
      <OktaLoginCallback />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    </>
  );
}
